import { render, staticRenderFns } from "./WidgetCreateOrChooseRole.vue?vue&type=template&id=c60eeabc&lang=pug"
import script from "./WidgetCreateOrChooseRole.vue?vue&type=script&lang=ts"
export * from "./WidgetCreateOrChooseRole.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports